import Ajax from '../../../common/js/Ajax.js';
import ButtonUtils from '../../../common/js/ButtonUtils.js';
import DatePicker from '../../../common/js/datepicker/DatePickerWidget.js';
import Form from '../../../common/js/form/Form.js';
import MessageUtils from '../../../common/js/MessageUtils.js';
import Widget from '../../../common/js/Widget.js';

import KCALS_TABLE_TEMPLATE from './EstrellaWidget-kcals-table.hbs';

const MINIMUM_POINTS = -9;
const MAXIMUM_POINTS = 80;

const MINIMUM_ESTRELLAS = -5;
const MAXIMUM_ESTRELLAS = 10;

export default class EstrellaWidget extends Widget {
	constructor($widget) {
		super($widget);

		this.adjustPointsRunning = false;
		this.adjustPointsDate = 0;
		this.adjustEstrellasRunning = false;
		this.adjustEstrellasDate = 0;

		Ajax.rpc(
			'/getLoggedInUser',
			user => {
				if (user) {
					this.user = user;
					this.refresh();
					this.initializeHandlers();
				} else {
					window.location.href = '/login';
				}
			},
			error => {
				MessageUtils.error($widget, 'Fehler beim Überprüfen des Logins', error);
			}
		);
	}

	adjustPoints() {
		if (this.adjustPointsRunning) {
			this.adjustPointsAnotherNeeded = true;
			return;
		}

		this.adjustPointsRunning = true;
		this.updatePoints();

		Ajax.rpc('/adjustPoints', {points: this.points}, () => {
			this.adjustPointsRunning = false;
			this.adjustPointsDate = new Date().getTime();
			this.updatePoints();
			window.setTimeout(() => {
				this.updatePoints();
			}, 3100);

			if (this.adjustPointsAnotherNeeded) {
				this.adjustPointsAnotherNeeded = false;
				this.adjustPoints();
			}
		});
	}

	adjustEstrellas() {
		if (this.adjustEstrellasRunning) {
			this.adjustEstrellasAnotherNeeded = true;
			return;
		}

		this.adjustEstrellasRunning = true;
		this.updateEstrellas();

		Ajax.rpc('/adjustEstrellas', {estrellas: this.estrellas}, () => {
			this.adjustEstrellasRunning = false;
			this.adjustEstrellasDate = new Date().getTime();
			this.updateEstrellas();
			window.setTimeout(() => {
				this.updateEstrellas();
			}, 3100);

			if (this.adjustEstrellasAnotherNeeded) {
				this.adjustEstrellasAnotherNeeded = false;
				this.adjustEstrellas();
			}
		});
	}

	handlePointsChange(delta) {
		this.points += delta;
		if (this.points < MINIMUM_POINTS) this.points = MINIMUM_POINTS;
		if (this.points > MAXIMUM_POINTS) this.points = MAXIMUM_POINTS;

		this.adjustPoints();
	}

	handleEstrellasChange(delta) {
		this.estrellas += delta;
		if (this.estrellas < MINIMUM_ESTRELLAS) this.estrellas = MINIMUM_ESTRELLAS;
		if (this.estrellas > MAXIMUM_ESTRELLAS) this.estrellas = MAXIMUM_ESTRELLAS;

		this.adjustEstrellas();
	}

	handleKcalsSave() {
		const $form = this.$widget.find('.js_kcals-form');
		if (Form.validate($form).length) {
			return;
		}

		const $date = $form.find('.js_kcals-date');
		const date = DatePicker.getDate($date);

		const $kcals = $form.find('[name="kcals"]');
		const kcals = parseInt($kcals.val(), 10);

		const $saveButton = this.$widget.find('.js_kcals-save');
		ButtonUtils.setState($saveButton, 'active');
		Ajax.rpc('/recordKcals', {date, kcals}, () => {
			ButtonUtils.setState($saveButton, 'success');
			$kcals.val('');
			this.refresh();
		});
	}

	initializeHandlers() {
		this.$widget.find('.js_points-minus').click(() => this.handlePointsChange(-1));
		this.$widget.find('.js_points-plus').click(() => this.handlePointsChange(1));
		this.$widget.find('.js_estrellas-minus').click(() => this.handleEstrellasChange(-1));
		this.$widget.find('.js_estrellas-plus').click(() => this.handleEstrellasChange(1));

		this.$widget.find('.js_kcals-save').click(() => this.handleKcalsSave(1));
	}

	isLoginRequired() {
		return true;
	}

	refresh() {
		Ajax.rpc(
			'/getUserAndDays',
			user => {
				this.points = user.points;
				this.estrellas = user.estrellas;

				this.updatePoints();
				this.updateEstrellas();

				this.$widget.find('.js_kcals-table').html(KCALS_TABLE_TEMPLATE(user.lastDays));
			},
			error => {
				MessageUtils.error(this.$widget, 'Laden der Seite fehlgeschlagen', error);
			}
		);
	}

	updatePoints() {
		const $points = this.$widget.find('.js_points');
		$points.text(this.points);
		$points.toggleClass('is-negative', this.points < 0);

		this.$widget.find('.js_points-saving').toggle(this.adjustPointsRunning);
		this.$widget
			.find('.js_points-saved')
			.toggle(!this.adjustPointsRunning && new Date().getTime() - this.adjustPointsDate < 3000);
	}

	updateEstrellas() {
		const $estrellas = this.$widget.find('.js_estrellas');
		$estrellas.text(this.estrellas);
		$estrellas.toggleClass('is-negative', this.estrellas < 0);

		this.$widget.find('.js_estrellas-saving').toggle(this.adjustEstrellasRunning);
		this.$widget
			.find('.js_estrellas-saved')
			.toggle(
				!this.adjustEstrellasRunning && new Date().getTime() - this.adjustEstrellasDate < 3000
			);
	}
}
